// BEM NAMES
export const PRODUCT_BLOCK = 'product';
export const PRICE_BLOCK = 'price';
export const CURRENT_PRICE_ELEMENT = `${PRICE_BLOCK}__current`;
export const REGULAR_PRICE_ELEMENT = `${PRICE_BLOCK}__regular`;
export const DELIVERY_DATE_BLOCK = 'delivery-date';
export const SIZE_BLOCK_ELEMENT = `${PRODUCT_BLOCK}__size`;

// DATA PROPERTY NAMES
export const PRICE = 'price';
export const REGULAR_PRICE = 'regular-price';



// WEBPACK FOOTER //
// ./styleguide/src/assets/lib/constants/pdp.js